import { DataInteractive } from "lib/headlessui/components/data-interactive/data-interactive";
import React, { forwardRef } from "react";
import { Link as UpstreamLink } from "react-router-dom";

export const Link = forwardRef(function Link(
    props: { href: string } & React.ComponentPropsWithoutRef<"a">,
    ref: React.ForwardedRef<HTMLAnchorElement>,
) {
    const { href, ...rest } = props;
    const isExternal = href.startsWith("http://") || href.startsWith("https://");

    if (isExternal) {
        return (
            <DataInteractive>
                <a href={href} {...rest} ref={ref} />
            </DataInteractive>
        );
    }

    return (
        <DataInteractive>
            <UpstreamLink to={href} {...rest} ref={ref} />
        </DataInteractive>
    );
});
